import React from "react";
import MainRouter from "./MainRouter";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@material-ui/styles";

import theme from "./theme";
import { VideoContext, useVideoReducer } from "./libs/contextLib";
import useSpeechSynthesis from "./libs/useSpeechSynthesis";

const App = () => {
  const [state, dispatch] = useVideoReducer();
  const speech = useSpeechSynthesis();
  //console.log("App speech=", speech);
  //console.log("App state.speech=", state.speech);
  if (!state.speech) {
    //console.log("undefined App speech=", speech);
    dispatch({ type: "setSpeech", payload: speech });
  } else if (state.speech.voices.length === 0 && speech.voices.length > 0) {
    //console.log("zero voice App speech=", speech);
    dispatch({ type: "setSpeech", payload: speech });
  }
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <VideoContext.Provider value={{ state, dispatch }}>
          <MainRouter />
        </VideoContext.Provider>
      </ThemeProvider>
    </Router>
  );
};

export default App;
